import { connect } from 'react-redux';
import { projectRouteTreeTooltipDataChanged } from '@Pages/RetroSynthesis/ProjectRoutes/actions';
import { getRoutesTreeTooltip } from '@Pages/RetroSynthesis/ProjectRoutes/selectors';
import RouteOverviewTreeTooltip from '@Pages/RetroSynthesis/RouteTree/components/RouteOverviewTreeTooltip';

const mapStateToProps = (state) => ({
  treeTooltip: getRoutesTreeTooltip(state),
});

const mapActionToProps = {
  updateTreeThumbnailDetails: projectRouteTreeTooltipDataChanged,
};

export default connect(mapStateToProps, mapActionToProps)(RouteOverviewTreeTooltip);
